import { NgIf, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { CategorySvgComponent } from '@curbnturf/custom-svgs';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { ActivityLocation, DEFAULT_IMAGE_URL, HelperFunctions, IRoutePoint, User } from '@curbnturf/entities';
import { SaveFavoriteComponent } from '@curbnturf/listing-edit';
import { TripPlannerFacade } from '@curbnturf/trip-planner/src/lib/+state/trip-planner.facade';
import { UserFacade } from '@curbnturf/user/src/lib/+state/user.facade';
import { IonicModule } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'curbnturf-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  imports: [NgIf, NgStyle, IonicModule, SiteSvgsComponent, CategorySvgComponent, SaveFavoriteComponent],
})
export class ActivityCardComponent implements OnChanges, OnInit, OnDestroy {
  @Input() activity?: ActivityLocation;
  @Output() closeBubble: EventEmitter<void> = new EventEmitter<void>();

  name: string;

  photoUrl: string = '';

  user: User;

  subscriptions: Subscription[] = [];

  get favorite(): boolean {
    return !!this.user?.poiFavorites?.find((favorite) => favorite.poiId === this.activity?.id);
  }

  constructor(
    private activityLocationFacade: ActivityLocationFacade,
    private cd: ChangeDetectorRef,
    private tripPlannerFacade: TripPlannerFacade,
    private userFacade: UserFacade,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.userFacade.currentUser$.subscribe((user) => {
        this.user = user;
        this.cd.detectChanges();
      }),
    );
  }

  ngOnChanges() {
    if (this.activity) {
      if (this.activity.photos && this.activity.photos.length > 0) {
        this.photoUrl = HelperFunctions.getPhotoUrl3x4Small(this.activity.photos[0]);
      } else {
        this.photoUrl = DEFAULT_IMAGE_URL;
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  onFavorite(event: Event) {
    event.stopPropagation();

    if (this.activity) {
      if (this.favorite) {
        this.activityLocationFacade.unfavorite(this.activity);
      } else {
        this.activityLocationFacade.favorite(this.activity);
      }
    }
  }

  onAddToTrip(event: Event) {
    event.stopPropagation();
    if (this.activity?.coordinates) {
      const point: IRoutePoint = {
        isPoi: true,
        poi: {
          ...this.activity,
        },
        name: this.activity?.name,
        coordinates: this.activity.coordinates,
        isActive: true,
      };
      this.tripPlannerFacade.addPoint(point, true);
    }
    this.closeBubble.emit();
  }
}
